<template>
  <v-card class="border">
    <v-card-title class="d-flex justify-space-between align-center">
      {{ $ucfirst($t('general')) }}
<!--      <v-btn-->
<!--        right-->
<!--        outlined-->
<!--        icon-->
<!--        color="primary"-->
<!--        :to="{ name: 'PatientEdit' }"-->
<!--      >-->
<!--        <eva-icon :fill="$color.coro.purple" name="edit-2-outline" />-->
<!--      </v-btn>-->
    </v-card-title>
    <v-simple-table class="patient-overview__table">
      <template v-slot:default>
        <tbody>
          <tr
            v-for="(item, index) in tableData"
            :key="`${item.label}-${index}`"
          >
            <td>{{ item.label }}</td>
            <td>{{ item.value }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <tablet-session-q-r
      v-if="patientId && !hasReadOnlyAccess"
      class="patient-overview-general__qr mb-15"
      :subject-id="studyId"
      :version-number="currentVersion"
      :user-name="studyId"
      :controls="false"
      :isMinimized="true"
      :locale="$store.state.currentLanguage || 'en'"
    />
    <div class="patient-overview-general__controls mb-15" v-disable-all="hasReadOnlyAccess">
      <reset-password-button :patient-id="patientId"></reset-password-button>
      <unblock-account-button :patient-id="patientId"></unblock-account-button>

      <v-btn
        class="mr-4 mb-4 btn-wrap"
        text
        x-large
        color="error"
        @click="logoutMobileApp"
      >
        <v-icon class="patient-overview__icon">mdi-logout</v-icon>
        {{ $ucfirst($t('login.logoutmobileapp')) }}
      </v-btn>
      <drop-out-button :patient-id="patientId"></drop-out-button>
    </div>

    <div v-if="$store.getters['isTestingEnvironment']">
      <v-card-title class="d-flex justify-space-between align-center">
        {{ $ucfirst($t('patient.loadScenario')) }}
      </v-card-title>
      <scenario-list :subject-id="studyId" />
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import TabletSessionQR from "dashboard/templates/components/Questionnaire/TabletSessionQR";
import DropOutButton from 'dashboard/templates/components/Parts/DropOutButton';
import ResetPasswordButton from "../../../components/Parts/ResetPasswordButton";
import ScenarioList from "../../../components/Parts/Scenario/ScenarioList";
import UnblockAccountButton from "../../../components/Parts/UnblockAccountButton.vue";

/**
 * Component PatientOverviewGeneral.vue
 *
 * @module PatientOverviewGeneral
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/views/Patient/Overview/PatientOverviewGeneral.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientOverviewGeneral',
  components: {
    ScenarioList,
    ResetPasswordButton,
    TabletSessionQR,
    DropOutButton,
    UnblockAccountButton
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
      initials: 'patientSummary/initials',
      gender: 'patientSummary/gender',
      birthYear: 'patientSummary/yearOfBirth',
      studyId: 'patientSummary/studyId',
      startDate: 'patientSummary/startDate',
      currentVersion: 'patientSummary/currentVersion',
      hasReadOnlyAccess: 'user/hasReadOnlyAccess'
    }),
    tableData() {
      return [
        {
          label: this.$ucfirst(this.$t('pdf.medicationPrescription.subjectId', {catalog: 'messages'})),
          value: this.studyId,
        },
        {
          label: this.$ucfirst(this.$t('patient.gender')),
          value: this.$ucfirst(this.$t(this.gender)),
        },
        {
          label: this.$ucfirst(this.$t('patient.yearofbirth')),
          value: this.birthYear,
        },
        {
          label: this.$ucfirst(this.$t('patient.startdate')),
          value: this.startDate,
        },
      ];
    },
  },
  methods: {
    async logoutMobileApp() {
      const success = await this.$store.dispatch('patientSummary/logOut', this.patientId);

      if (success) {
        this.$toasted.show(this.$ucfirst(this.$t('successMessages.patientMobileLoggedOut')), {
          type : 'success',
          icon : 'check',
          position: 'bottom-center',
        });
      }
    },
  },
};
</script>

<style lang="scss">
.patient-overview-general__names {
  margin-right: 50px;
}

.patient-overview-general__qr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
</style>
